import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import VideoBlockEditing from './video/videoblockediting';
import './theme/video.css';
export default class VideoBlock extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [VideoBlockEditing, Widget];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'VideoBlock';
    }
}
//# sourceMappingURL=videoblock.js.map